export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const TOGGLE_LOADING_USER_DETAILS = 'TOGGLE_LOADING_USER_DETAILS';
export const TOGGLE_EMAIL_LOADING = 'TOGGLE_EMAIL_LOADING';
export const TOGGLE_SENDOTP_LOADING = 'TOGGLE_SENDOTP_LOADING';

